<template>
  <div class="edit-bill-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" label-width="200px" :rules="rules">
        <el-form-item label="商户id:" v-if="title === '编辑商人'" prop="uid">
          <el-input size="small" placeholder="请输入商户id" v-model="params.uid"></el-input>
        </el-form-item>
        <el-form-item label="账户名:" prop="name">
          <el-input size="small" placeholder="请输入账户名" v-model="params.name"></el-input>
        </el-form-item>
        <el-form-item label="密码" v-if="this.type !=='edit'" prop="password">
          <el-input size="small" placeholder="请输入密码" v-model="params.password"></el-input>
        </el-form-item>
        <el-form-item v-if="this.type ==='edit'" label="密码:">
          <el-button @click="handleModifyPassword" v-if="!isModify" type="info" size="mini">修改密码</el-button>
          <el-input v-else size="small" placeholder="请输入密码" v-model="password">
            <template slot="append">
              <el-button size="small" plain @click="handleModifyPassword">取消修改</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="昵称:" prop="nickname">
          <el-input size="small" placeholder="请输入昵称" v-model="params.nickname"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input size="small" placeholder="请输入邮箱" v-model="params.email"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="mobile">
          <el-input size="small" placeholder="请输入手机号" v-model="params.mobile"></el-input>
        </el-form-item>
        <el-form-item label="商人所属聚商ID:" prop="cid" v-if="this.type === 'edit'">
          <el-input disabled size="small" placeholder="请输入商人所属聚商ID" v-model="params.cid"></el-input>
        </el-form-item>
        <el-form-item label="商人余额:" prop="balance" v-if="this.title === '新增商人'">
          <el-input size="small" placeholder="请输入商人余额" v-model="params.balance"></el-input>
        </el-form-item>
        <el-form-item label="是否禁止登录:" prop="hasLocked" placeholder="是否禁止登陆">
          <el-select v-model.number="params.hasLocked">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="角色:" prop="privilegeID">
          <el-select v-model="params.privilegeID" size="small">
            <el-option v-for="item in privilegeIDList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
export default {
  data() {
    return {
      password: "",
      type: "", //弹出框类型
      isModify: false, //不显示修改密码
      id: "",
      title: "",
      dialogVisible: false,
      flag: false,
      // 请求角色列表参数
      params1: {
        pageNumber: 1,
        pageSize: 10,
      },
      privilegeIDList: [],
      // 状态列表
      params: {
        uid: undefined,
        name: undefined,
        password: undefined,
        email: undefined,
        mobile: undefined,
        cid: undefined,
        channel: undefined,
        wechat: undefined,
        balance: undefined,
        qq: undefined,
        hasLocked: undefined,
        privilegeID: "5ea7d8e4f75106b234960324",
        privilegeNam: "",
      },
      rules: {
        uid: [{ required: true, message: "必填", trigger: "change" }],
        name: [{ required: true, message: "必填", trigger: "change" }],
        password: [{ required: true, message: "必填", trigger: "change" }],
        nickname: [{ required: true, message: "必填", trigger: "change" }],
        email: [{ required: true, message: "必填", trigger: "change" }],
        mobile: [{ required: true, message: "必填", trigger: "change" }],
        balance: [{ required: true, message: "必填", trigger: "change" }],
        hasLocked: [{ required: true, message: "必选", trigger: "change" }],
      },
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.title === "编辑商人") {
            if (this.isModify) {
              this.params.password = this.password;
            } else {
              this.params.password = undefined;
            }
            this.handleEditBusinseeman();
          } else {
            this.handleAddBusinseeman();
          }
        } else {
          return false;
        }
      });
    },
    // 角色选择列表
    // getAuthorList(params) {
    //   API.getAuthorList(params).then(res => {

    //     if (res.code === 200 && res.data) {
    //       this.privilegeIDList = this.privilegeIDList.concat(res.data.list.map(item => {
    //         return {
    //           label: item.role,
    //           value: item.id
    //         }
    //       }))
    //       if (params.pageNumber * params.pageSize < res.data.total) {
    //         params.pageNumber += 1
    //         this.getAuthorList(params)
    //       } else {
    //         return false
    //       }
    //     }
    //   })
    // },
    handleAddBusinseeman() {
      this.params.balance = parseFloat(this.params.balance);
      API.addBusinessman(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增商人成功",
              type: "success",
            });
            this.$emit("handlerBillList");
          } else {
            this.$message.error("新增商人失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    handleModifyPassword() {
      this.password = "111";
      this.isModify = !this.isModify;
      if (this.isModify) {
        this.password = undefined;
      }
    },
    handleEditBusinseeman() {
      this.params.balance = parseFloat(this.params.balance);
      API.editBusinessman(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑商人成功",
              type: "success",
            });
            this.$emit("handlerBillList");
          } else {
            this.$message.error("编辑商人失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    open(type, row) {
      this.dialogVisible = true;
      // this.getAuthorList(this.params1)
      this.type = type;
      if (type === "edit") {
        this.title = "编辑商人";

        this.params = row;
      } else {
        this.title = "新增商人";
      }
    },
    // 关闭弹窗时
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        uid: undefined,
      };
      this.$refs["form"].resetFields();
    },
  },
};
</script>
<style scoped>
.el-input {
  width: 220px;
}
</style>
